import { OptionType } from 'types/OptionType'

type ChipsButtonProps = {
  options: OptionType[]
  placeholder?: string
}

export default function ChipsButton({ options, placeholder = `Select options` }: ChipsButtonProps) {
  if (options.length === 0) {
    return (
      <div className="flex min-h-[42px] w-full items-center rounded-lg border border-default bg-surface px-3 py-2 text-body-sm text-minimal shadow-elevation-1">
        {placeholder}
      </div>
    )
  }

  return (
    <div className="flex min-h-[42px] w-full flex-wrap items-center gap-1 rounded-lg border border-default bg-surface px-3 py-2 shadow-elevation-1">
      {options.map((option) => (
        <span
          key={option.id}
          className="flex h-5 items-center gap-1 rounded border-[0.5px] border-default bg-(--fg-strong)/8 px-1.5 py-0.5 text-body-sm"
        >
          {option.name}
        </span>
      ))}
    </div>
  )
}
